import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function HeartFill(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    d: "M14.328 2.494a6.121 6.121 0 014.815 0 6.254 6.254 0 012.033 1.401 6.447 6.447 0 011.351 2.086 6.58 6.58 0 010 4.902 6.448 6.448 0 01-1.351 2.086l-8.458 8.727a1 1 0 01-1.436 0l-8.458-8.728A6.52 6.52 0 011 8.432a6.52 6.52 0 011.824-4.537 6.182 6.182 0 014.44-1.894c1.671 0 3.268.685 4.44 1.894l.296.306.296-.305a6.254 6.254 0 012.032-1.402z"
  }));
}

export default HeartFill;